let marketpaceServer = '_FFFFFFFFFFFFFF00001689753917693088_';
const RTABLESERVER = '_FFFFFFFFFFFFFF00001713960477110008_';
/*marketplace_condition_json = {
    "conditions": "AND",
    "rules": [
        {"field": "name", "operator": "like", "value": "%John%"},
        {"field": "age", "operator": "greater", "value": 30},
        {
            "conditions": "OR",
            "rules": [
                {"field": "status", "operator": "equal", "value": "active"},
                {"field": "status", "operator": "equal", "value": "pending"}
            ]
        }
    ]
}*/

function CreateConversationPost(viewport, client,newData, store) {
    console.log("CreateConversationPost :",viewport,"===",client,"====",newData);
    let clientObj = window.botStore.getClientByViewPort(viewport);
    let GrantPath = JSON.parse(clientObj.ClientContext);
    let GrantPE = GrantPath.GrantPE;
    let currentContext = JSON.parse(clientObj.CurrentContext);
  
    let marketplaceMessage = {
      welcomemessage : "Thank you for Connecting with Simplia. Simplia helps you Get Things Done",
      typeofservice : "Would you like to Request a Service or Offer a Service?",
    };
    //window.BotServices.startIvrBot();
    let OpenPE = window.top.oxygenUtil.createSimpleOES(["Provider","_FFFFFFFFFFFFFF00001731965965540235_","Provider","_FFFFFFFFFFFFFF00001731965965540235_"]);
    console.log("set inbox openpe :",OpenPE);              
 //   await oxygenUtil.callMessageBoxFnWithReturn(viewport,'addRecipientPE',[OpenPE]);
 //   await window.top.oxygenUtil.callMessageBoxFnWithReturn(viewport,"setupSend",[OpenPE]);
    
    let Params= {};
    Params.EventTemplate = "_FFFFFFFFFFFFFF00001575595750910042_";
    Params.EventRegistrant = "_FFFFFFFFFFFFFF00001575882222359002_";
    Params.Label = "Message";
    Params.NoteTemplateID = "_FFFFFFFFFFFFFF00001633127893643639_";
    Params.ToPE = currentContext.grantItem.GrantPE;
    Params.ByPE = currentContext.grantItem.GrantPE;
  //  Params.ByPE = "11Provider%7F1_FFFFFFFFFFFFFF00001731965965540235_%7F1Provider%7F1_FFFFFFFFFFFFFF00001731965965540235_%7F%7F";
    Params.GrantID = currentContext.grantItem.GrantID;
    Params.AttributionID = currentContext.Account.ID;
    Params.RootEventID = "";
    Params.CausingEventID = "";
    Params.argJSON = { expandByDefault: true };
    
    let urlparams = "what="+newData.What+"&when="+newData.When+"&where="+newData.Where+"&coins="+newData.Coin+"&merit="+newData.Merit+"&currency="+newData.currency+"&SearchString="+newData.SearchString+"&EventTemplate="+Params.EventTemplate+"&NoteTemplateID="+Params.NoteTemplateID+"&toPE="+Params.ByPE+"&byPE="+ Params.ToPE+"&grantId="+currentContext.grantItem.GrantID+"&AttributionId="+currentContext.AttributionID+"&RootEventID=''&CausingEventID=''";
    let confirmReply = `<iframe src="https://debianlargeserver-0050-kamalk-0054.laxroute53.com/DeepLander-0086/ConversationBots/MarketplaceAI/showRequest.html?${urlparams}" height="200" width="300" title="Iframe Example"></iframe>`;
    window.DevMgr.postToHistory(Params,confirmReply,(err,result)=>{
      if(result){
     //    window.DevMgr.postToHistory(Params,marketplaceMessage.typeofservice,()=>{});
        let GraphTemplateID = "_FFFFFFFFFFFFFF00001745532650295205_/11admin1_FFFFFFFFFFFFFF00001731965965540235_1Editor1_FFFFFFFFFFFFFF00001745532650295205_";
        let TemplateName = "Conversation Marketplace-0046";
        ConfirmSmartLinkPost(client, viewport,GraphTemplateID, TemplateName,newData);
      }
    });
    
  
}

  function createSmartLink(params,clientId) {
    //let RTablesFields = {"Message":agreementData.SearchString,"What":What,"When":When,"Where":Where,"Merits":Merits,"Points":Coins,"Credits":Currency,"Post ID":result.Node,"Post Name":result.DisplayName,"Transaction Code":"","Post Role":agreementData.PostRole};
    let client = window.top.botStore.getClientByID(clientId);
    console.log("Got client data for mp post: ", client.ClientRightRole);
    let currentContext = JSON.parse(client.CurrentContext);
    console.log("currentContext smart link :",currentContext);

    const url = '/VueOrderPage/System/ServerSide/get-customer-link';
  
    const payload = {
      content: "<h1>Welcome to Simplia!</h1><h3>Your page will be ready mailto:soon!</h3>",
      label: params["Post Name"],
      attributionId: params.Attribution,
      leadId: params["Post ID"],
      domain :"https://debianlargeserver-0050-kamalk-0054.laxroute53.com/"
    };
  
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('smart link Server responded with status ' + response.status);
      }
      return response.json(); // or .text() based on expected return
    })
    .then(data => {
      console.log('smart link Response from server:', data);

      let urlparams = "clientID="+client.Client+"&PostID="+params["Post ID"]+"&PostName="+params["Post Name"]+"&url="+data.url;
      let reply = `<iframe src="https://debianlargeserver-0050-kamalk-0054.laxroute53.com/DeepLander-0086/ConversationBots/MarketplaceAI/SmartLink.html?${urlparams}" height="200" width="300" title="Iframe Example"></iframe>`;
      
      let Params= {};
        Params.EventTemplate = "_FFFFFFFFFFFFFF00001575595750910042_";
        Params.EventRegistrant = "_FFFFFFFFFFFFFF00001575882222359002_";
        Params.Label = "Message";
        Params.NoteTemplateID = "_FFFFFFFFFFFFFF00001633127893643639_";
        Params.ToPE = currentContext.grantItem.GrantPE;
        Params.ByPE = currentContext.grantItem.GrantPE;
    //  Params.ByPE = "11Provider%7F1_FFFFFFFFFFFFFF00001731965965540235_%7F1Provider%7F1_FFFFFFFFFFFFFF00001731965965540235_%7F%7F";
        Params.GrantID = currentContext.grantItem.GrantID;
        Params.AttributionID = currentContext.Account.ID;
        Params.RootEventID = "";
        Params.CausingEventID = "";
        Params.argJSON = { expandByDefault: true };
        
      window.DevMgr.postToHistory(Params,reply,(err,result)=>{
        if(result){
       //    window.DevMgr.postToHistory(Params,marketplaceMessage.typeofservice,()=>{});
        }
      });  
      attachChatboxToSmartLink(data);
    })
    .catch(error => {
      console.error('smart link Error posting data:', error);
    });
  }
  
  function attachChatboxToSmartLink(data) {
  //  const url = 'https://debianlargeserver-0050-simpliasites.laxroute53.com/VueOrderPage/System/ServerSide/set-customer-link-new';
    const url = '/VueOrderPage/System/ServerSide/set-customer-link';
  
    const payload = {
      smart_link: data.url
    };
  
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Server error: ' + response.status);
      }
      return response.json(); // use response.text() if the API returns plain text
    })
    .then(data => {
      console.log('Response from server:', data);
    })
    .catch(error => {
      console.error('POST request failed:', error);
    });
  }
  
  function ConfirmSmartLinkPost(client, viewportId,GraphTemplateID, TemplateName,params) {
    let RightId="",What=params.What,When=params.When,Where=params.Where,Coins=params.Coin,Merits=params.Merit,Currency=params.currency,SearchString=params.SearchString,event="";
    
    console.log("confirm rtable agreement: ", client,"====params===========",GraphTemplateID,"==",TemplateName);
    let clientObj = window.top.botStore.getClientByID(client);
    console.log("Got client data for mp post: ", clientObj.ClientRightRole);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    console.log("currentContext smart link :",currentContext);
    
    let meetingContext = JSON.parse(clientObj.MeetingContext);
    let agreementData = {};
    //let selectedPostTemplate = data.GraphTemplateID;
    //let selectedPostTemplateDN = data.GraphTemplateDN;

    //if(clientObj.ClientRightRole == 'Customer') {
    let selectedTemplate = GraphTemplateID.split('/'); 
    let selectedPostTemplate = selectedTemplate[0];
    let selectedPostTemplateDN = selectedTemplate[1]
    //}
    
    agreementData.PostRole = 'Provider';
    
    agreementData.Action = "OfferService";
    agreementData.ActionType = "Post";
    agreementData.Address = "";
    agreementData.Category = "";
    agreementData.Distance = "";
    agreementData.Location = "";
    agreementData.Name = "";
    agreementData.Price = Currency;
    agreementData.Merit = Merits;
    agreementData.Point = Coins;
    agreementData.SearchString= SearchString;
    agreementData.Title = What
    agreementData.What = What;
    agreementData.When = When;
    agreementData.Where = Where;
    //agreementData.TemplateID = "_FFFFFFFFFFFFFF00001715786625384195_";
    //agreementData.TemplateName = "Simple Post";
    agreementData.TemplateID = selectedPostTemplate;
    agreementData.TemplateName = TemplateName;
    agreementData.TemplateGrantPE = selectedPostTemplateDN;

    
    let PostParams = {
        componentId: RTABLESERVER,
        command: "CreatePost",
        data: {Context : currentContext, InitialContext : agreementData, TemplateID : agreementData.TemplateID, DisplayName : agreementData.SearchString, Role : agreementData.PostRole, "TableId":"_FFFFFFFFFFFFFF00001731965965540235_","DeskInit" : {Node: "Begun", Behaviour : {Role : "admin" , Action : "Init", Result : "admin:Init/Inited"}} },
        Type: 'BotApi'
    }
    console.log("create post mp :",PostParams);

    window.top.BotServices.callComponent(PostParams, (err, result) => {
        console.log("CreatePost Got : ", result);
        
        if(result) { 
        
            let RTablesFields = {"Message":agreementData.SearchString,"What":What,"When":When,"Where":Where,"Merits":Merits,"Points":Coins,"Credits":Currency,"Post ID":result.Node,"Post Name":result.DisplayName,"Transaction Code":"","Post Role":agreementData.PostRole,"Attribution":clientObj.Attribution};
            
            let TableId = "_FFFFFFFFFFFFFF00001731965965540235_";
            let TableName="Local Marketplace V2";
            
            RTablesFields["Provider"] = currentContext.Account.GatewayRightDN;
            RTablesFields["Provider Attribution ID"] = currentContext.Account.AttributionID;
        

            let columnsdata = {"ClientID":clientObj.Client,"DisplayName":result.DisplayName,"TableId":TableId,"TableName":TableName,"RowData":RTablesFields};
            agreementData.PostName = result.DisplayName;
            console.log("Rtable fields",RTablesFields);
            
            createSmartLink(RTablesFields,clientObj.Client);
            InsertToRTable(clientObj.Client,agreementData,result,RTablesFields,TableId,TableName,selectedPostTemplate,selectedPostTemplateDN);
        }
        
    });    
  
}

function ConfirmRTablePost(client, viewportId,data, store) {
    console.log("confirm rtable agreement: ", client,"====params===========",data);
    let clientObj = window.botStore.getClientByID(client);
    console.log("Got client data for mp post: ", clientObj.ClientRightRole);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    let meetingContext = JSON.parse(clientObj.MeetingContext);
    let agreementData = {};
    //let selectedPostTemplate = data.GraphTemplateID;
    //let selectedPostTemplateDN = data.GraphTemplateDN;

    //if(clientObj.ClientRightRole == 'Customer') {
       let selectedTemplate = data.GraphTemplateID.split('/'); 
       let selectedPostTemplate = selectedTemplate[0];
       let selectedPostTemplateDN = selectedTemplate[1]
    //}
    
    if(data.Action == 'RequestService') {
        agreementData.PostRole = 'Customer';
    } else if(data.Action == 'OfferService') {
        agreementData.PostRole = 'Provider';
    }
    agreementData.Action = data.Action;
    agreementData.ActionType = data.ActionType;
    agreementData.Address = data.Address;
    agreementData.Category = data.Category;
    agreementData.Distance = data.Distance;
    agreementData.Location = data.Location;
    agreementData.Name = data.Name;
    agreementData.Price = data.Price;
    agreementData.Merit = data.Merit;
    agreementData.Point = data.Point;
    agreementData.SearchString= data.SearchString;
    agreementData.Title = data.Title;
    agreementData.What = data.What;
    agreementData.When = data.When;
    agreementData.Where = data.Where;
    //agreementData.TemplateID = "_FFFFFFFFFFFFFF00001715786625384195_";
    //agreementData.TemplateName = "Simple Post";
    agreementData.TemplateID = selectedPostTemplate;
    agreementData.TemplateName = data.GraphTemplateDN;
    agreementData.TemplateGrantPE = selectedPostTemplateDN;


    if(data && data.ActionType == "Post" && clientObj && (clientObj.ClientRightRole == 'Provider' || clientObj.ClientRightRole == 'admin' || clientObj.ClientRightRole == 'Customer')) {
        
        let PostParams = {
            componentId: RTABLESERVER,
            command: "CreatePost",
            data: {Context : currentContext, InitialContext : agreementData, TemplateID : agreementData.TemplateID, DisplayName : data.PostName, Role : agreementData.PostRole, "TableId":"_FFFFFFFFFFFFFF00001731965965540235_","DeskInit" : {Node: "Begun", Behaviour : {Role : "admin" , Action : "Init", Result : "admin:Init/Inited"}} },
            Type: 'BotApi'
        }
        console.log("create post mp :",PostParams);

        window.BotServices.callComponent(PostParams, (err, result) => {
            console.log("CreatePost Got : ", result);
            
            let RTablesFields = {"Message":agreementData.SearchString,"What":data.What,"When":data.When,"Where":data.Where,"Merits":data.Merit,"Points":data.Point,"Credits":data.Price,"Post ID":result.Node,"Post Name":result.DisplayName,"Transaction Code":"","Post Role":agreementData.PostRole};
            
            /*window.DevMgr.AddRow(columnsdata,(err,rowres) => {
                console.log("add row api got : ", rowres);
                if(rowres == "Row Added") {
                    let terminationUrlTable = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client};
                    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrlTable,"InitialContext" : {"Role":agreementData.PostRole}}, ()=>{});
                    
                } else {
                console.log("add row api got error: ", err);
                }
            });*/
            let TableId = "_FFFFFFFFFFFFFF00001731965965540235_";//clientObj.ClientRight;
            let TableName=clientObj.ClientRightDN;
            
            if(clientObj.ClientRightRole == 'Provider') {
                TableId = "_FFFFFFFFFFFFFF00001731965965540235_";//clientObj.ClientRight;
                TableName=clientObj.ClientRightDN;
                RTablesFields["Provider"] = currentContext.Account.GatewayRightDN;
                RTablesFields["Provider Attribution ID"] = currentContext.Account.AttributionID;
            } 

            if(clientObj.ClientRightRole == 'Customer') {
                TableId = agreementData.TemplateID;
                TableName= agreementData.TemplateName;
                RTablesFields["Customer"] = currentContext.Account.GatewayRightDN;
                RTablesFields["Customer Attribution ID"] = currentContext.Account.AttributionID;
            }

            let columnsdata = {"ClientID":client,"DisplayName":data.PostName,"TableId":"_FFFFFFFFFFFFFF00001731965965540235_","TableName":clientObj.ClientRightDN,"RowData":RTablesFields};
            agreementData.PostName = data.PostName;
            console.log("Rtable fields",RTablesFields);
            
            if(result) { 
                InsertToRTable(client,agreementData,result,RTablesFields,TableId,TableName,selectedPostTemplate,selectedPostTemplateDN,store);
            }
            
           // let url = "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/marketplace-wc/dist/js/app.js";
            //let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-marketplace',"URL":url};
            //window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrl}, ()=>{});

        });    
    } else {
        let terminationUrlTable = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client+"&what="+data.What};
        window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrlTable,"InitialContext" : {"Role":agreementData.PostRole}}, ()=>{});
    }
}

function ConfirmGlobalRTablePost(client, viewportId,data, store) {
    console.log("confirm rtable agreement: ", client,"====params===========",data);
    let clientObj = window.botStore.getClientByID(client);
    console.log("Got client data for mp post: ", clientObj.ClientRightRole);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    let meetingContext = JSON.parse(clientObj.MeetingContext);
    let agreementData = {};
    //let selectedPostTemplate = data.GraphTemplateID;
    //let selectedPostTemplateDN = data.GraphTemplateDN;

    //if(clientObj.ClientRightRole == 'Customer') {
       let selectedTemplate = data.GraphTemplateID.split('/'); 
       let selectedPostTemplate = selectedTemplate[0];
       let selectedPostTemplateDN = selectedTemplate[1]
    //}
    
    if(data.Action == 'RequestService') {
        agreementData.PostRole = 'Customer';
    } else if(data.Action == 'OfferService') {
        agreementData.PostRole = 'Provider';
    }
    agreementData.Action = data.Action;
    agreementData.ActionType = data.ActionType;
    agreementData.Address = data.Address;
    agreementData.Category = data.Category;
    agreementData.Distance = data.Distance;
    agreementData.Location = data.Location;
    agreementData.Name = data.Name;
    agreementData.Price = data.Price;
    agreementData.Merit = data.Merit;
    agreementData.Point = data.Point;
    agreementData.SearchString= data.SearchString;
    agreementData.Title = data.Title;
    agreementData.What = data.What;
    agreementData.When = data.When;
    agreementData.Where = data.Where;
    //agreementData.TemplateID = "_FFFFFFFFFFFFFF00001715786625384195_";
    //agreementData.TemplateName = "Simple Post";
    agreementData.TemplateID = selectedPostTemplate;
    agreementData.TemplateName = data.GraphTemplateDN;
    agreementData.TemplateGrantPE = selectedPostTemplateDN;
    var insertData ={};
    
    insertData.PostComponentID = currentContext.grantItem.GrantRightID ;
    insertData.PostGrantPE = currentContext.grantItem.GrantPE;
    insertData.PostcredentialId = currentContext.AttributionID;
    
    var insertPostData ={};
    insertPostData.PostText = data.SearchString;
    insertPostData.AttributionID = currentContext.AttributionID;
    insertData.Action = agreementData.Action;
    insertData.ActionType = agreementData.ActionType;
    insertData.SearchString = data.SearchString;
    insertPostData.mode = 'Web';
    var msgTime = new Date();
    insertPostData.CreationTime = msgTime;
    insertPostData.UpdateTime = msgTime;

    if(agreementData.Action == 'RequestService') {
        insertData.PostRole = 'Consumer';
    } else if(agreementData.Action == 'OfferService') {
        insertData.PostRole = 'Provider';
    }
    //insertData.Role = that.OnRole;
    currentContext.SearchString= data.SearchString;
    currentContext.insertData = insertData;
    currentContext.componentId = client;
    currentContext.accountId = currentContext.AttributionID;
    let postcontacts = currentContext.grantItem.GrantPE;
    currentContext.contacts = postcontacts;
    let clientContextData = {"ActionType":agreementData.ActionType,Action: agreementData.Action,SearchString: data.SearchString};
    console.log("==Landing page data===="+agreementData.ActionType+"==="+agreementData.Action+"====="+data.SearchString);
    currentContext.clientContextData = clientContextData;

    if(data && data.ActionType == "Post" && clientObj && (clientObj.ClientRightRole == 'Provider' || clientObj.ClientRightRole == 'Customer')) {
        
        let PostParams = {
            componentId: RTABLESERVER,
            command: "createMpPost",
            data: {Context : currentContext, InitialContext : agreementData, TemplateID : agreementData.TemplateID, DisplayName : data.PostName, Role : agreementData.PostRole, "TableId":clientObj.ClientRight,"DeskInit" : {Node: "Begun", Behaviour : {Role : "admin" , Action : "Init", Result : "admin:Init/Inited"}} },
            Type: 'BotApi'
        }
        console.log("create post mp global:",PostParams);

        window.BotServices.callComponent(PostParams,async (err, result) => {
            console.log("CreatePost global Got : ", result);
            
            let RTablesFields = {"Message":agreementData.SearchString,"What":data.What,"When":data.When,"Where":data.Where,"Merits":data.Merit,"Points":data.Point,"Credits":data.Price,"Post ID":result.Node,"Post Name":result.DisplayName,"Transaction Code":"","Post Role":agreementData.PostRole};
            //let ToPE = window.top.oxygenUtil.createSimpleOES(["Provider","_FFFFFFFFFFFFFF00001731965965540235_","Provider","_FFFFFFFFFFFFFF00001731965965540235_"]);
 
           // await window.top.oxygenUtil.sendPullPEHistoryMessage(clientObj.Client, ToPE, agreementData.TemplateGrantPE, { enableDeskMode: false }, { agreementData });
            
            /*window.DevMgr.AddRow(columnsdata,(err,rowres) => {
                console.log("add row api got : ", rowres);
                if(rowres == "Row Added") {
                    let terminationUrlTable = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client};
                    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrlTable,"InitialContext" : {"Role":agreementData.PostRole}}, ()=>{});
                    
                } else {
                console.log("add row api got error: ", err);
                }
            });*/
            let TableId = clientObj.ClientRight;
            let TableName=clientObj.ClientRightDN;
            
            if(clientObj.ClientRightRole == 'Provider') {
                TableId = clientObj.ClientRight;
                TableName=clientObj.ClientRightDN;
                RTablesFields["Provider"] = currentContext.Account.GatewayRightDN;
                RTablesFields["Provider Attribution ID"] = currentContext.Account.AttributionID;
            } 

            if(clientObj.ClientRightRole == 'Customer') {
                TableId = agreementData.TemplateID;
                TableName= agreementData.TemplateName;
                RTablesFields["Customer"] = currentContext.Account.GatewayRightDN;
                RTablesFields["Customer Attribution ID"] = currentContext.Account.AttributionID;
            }

            let columnsdata = {"ClientID":client,"DisplayName":data.PostName,"TableId":clientObj.ClientRight,"TableName":clientObj.ClientRightDN,"RowData":RTablesFields};
            agreementData.PostName = data.PostName;
            console.log("Rtable fields",RTablesFields);
            
            if(result) { 
                InsertToRTable(clientObj.Client,agreementData,result,RTablesFields,TableId,TableName,selectedPostTemplate,selectedPostTemplateDN,store);
            }
            
           // let url = "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/marketplace-wc/dist/js/app.js";
            //let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-marketplace',"URL":url};
            //window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrl}, ()=>{});

        });    
    } else {
        let terminationUrlTable = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client+"&what="+data.What};
        window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrlTable,"InitialContext" : {"Role":agreementData.PostRole}}, ()=>{});
    }
}

async function InsertToRTable(client,data,postResult,RowData,TableId,TableName,selectedPostTemplate,selectedPostTemplateDN,store) {
    let clientObj = window.botStore.getClientByID(client);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    console.log("insert to Rtable :",TableId, "===",TableName);

    //let RTablesFields = {"Message":data.SearchString,"What":data.What,"When":data.When,"Where":data.Where,"Merits":"","Points":"","Credits":data.Price,"Post_ID":postResult.Node,"Post Name":postResult.DisplayName,"Transaction Code":"","Post Role":data.PostRole};
    let PostParams = {
        componentId: RTABLESERVER,
        command: "InsertData",
        data: {Context : currentContext, "DisplayName":data.PostName,"TableId":TableId,"TableName":TableName,"RowData":RowData,"NewRow":postResult},
        Type: 'BotApi'
      }
      console.log("CreatePost params : ",PostParams);
      
      window.BotServices.callComponent(PostParams, async (err, result) => {
        console.log("CreatePost InsertData Got : ", result);
        let condition_json = {};
        if(result) {
            if(data.PostRole == "Provider" || data.PostRole == "admin") {
                let condition_json = {
                    "conditions": "OR",
                    "rules": [
                        {"field": "Post Role", "operator": "equal", "value": "Provider"},
                        {"field": "Post Role", "operator": "equal", "value": "Customer"}
                       /* {"field": "What", "operator": "like", "value": "%"+data.What+"%"}
                        {"field": "Post Role", "operator": "equal", "value": 30},
                        {
                            "conditions": "OR",
                            "rules": [
                                {"field": "status", "operator": "equal", "value": "active"},
                                {"field": "status", "operator": "equal", "value": "pending"}
                            ]
                        }*/
                    ]
                };
                let Account = window.top.botStore.getAccountByType('PersonalAccount');
                console.log("===Account====",Account);
                window.top.BotServices.PullPE(
                    {
                    ByClientID : clientObj.Client,
                    InitialContext : {
                        ByClientID : clientObj.Client
                    },
                    OpenPE :  window.top.oxygenUtil.createSimpleOES([Account.GatewayRightR,Account.GatewayRightID,"Provider","_FFFFFFFFFFFFFF00001731965965540235_"])
                    //OpenPE : "11holder1_FFFFFFFFFFFFFF00001586277513952707_1Provider1_FFFFFFFFFFFFFF00001731965965540235_"
                    }
                );
               // let terminationUrlTable = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client+"&what="+data.What};
               // window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrlTable,"InitialContext" : {"Role":data.PostRole}}, ()=>{});
           
            }
            console.log("selectedPostTemplate :",selectedPostTemplate);
            if(data.PostRole == "Customer"  && selectedPostTemplate == "_FFFFFFFFFFFFFF00001736021124446564_") {
                let condition_json = {
                    "conditions": "AND",
                    "rules": [
                       /* {"field": "What", "operator": "like", "value": "%Issue%"},
                        {"field": "Post Role", "operator": "equal", "value": "Provider"},*/
                        //{"field": "Provider" , "operator" : "equal", "value" : "kamal.simplia@gmail.com-0064"}
                    ]
                };
              //  let ToPE = window.top.oxygenUtil.createSimpleOES(["Provider","_FFFFFFFFFFFFFF00001731965965540235_","Provider","_FFFFFFFFFFFFFF00001731965965540235_"]);
 
                //await window.top.oxygenUtil.sendPullPEHistoryMessage(clientObj.Client, ToPE, data.TemplateGrantPE, { enableDeskMode: false }, { data });

                window.top.BotServices.PullPE(
                    {
                      ByClientID : clientObj.Client,
                      InitialContext : {
                        ByClientID : clientObj.Client
                      },
                      OpenPE : data.TemplateGrantPE
                    }
                 );
                 //let terminationUrlTable = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client};
                //window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrlTable,"InitialContext" : {"Role":data.PostRole,"QueryCondition":condition_json}}, ()=>{});
            }
            if(data.PostRole == "Customer" && selectedPostTemplate != "_FFFFFFFFFFFFFF00001736021124446564_") {
                console.log("selectedPostTemplate not matched");
                let condition_json = {
                    "conditions": "AND",
                    "rules": [
                        /*{"field": "What", "operator": "like", "value": "%"+data.What+"%"},*/
                        {"field": "Post Role", "operator": "equal", "value": "Provider"}
                    ]
                };
                let Account = window.top.botStore.getAccountByType('PersonalAccount');
                console.log("===Account====",Account);
                window.top.BotServices.PullPE(
                    {
                    ByClientID : clientObj.Client,
                    InitialContext : {
                        ByClientID : clientObj.Client
                    },
                    OpenPE :  window.top.oxygenUtil.createSimpleOES([Account.GatewayRightR,Account.GatewayRightID,"Provider","_FFFFFFFFFFFFFF00001731965965540235_"])
                    //OpenPE : "11holder1_FFFFFFFFFFFFFF00001586277513952707_1Provider1_FFFFFFFFFFFFFF00001731965965540235_"
                    }
                );
//                let terminationUrlTable = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client+"&what="+data.What};
 //               window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Marketplace', Termination : terminationUrlTable,"InitialContext" : {"Role":data.PostRole}}, ()=>{});
            }    

        }
    }); 
}

function ConfirmGlobalAgreement(client, viewportId,data, store) {
    /* Create Indexes for Root Menu */
    console.log("Got data for confirm global agreement: ", client,"====params====",data);
    let clientObj = window.botStore.getClientByID(client);
    console.log("Got client data for end call: ", clientObj);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    let meetingContext = JSON.parse(clientObj.MeetingContext);
    //window.BotServices.callManagerApi({action:'stopCall', data : {ClientID : client,ConferenceID : meetingContext.MeetingId,MeetingParentId:meetingContext.MeetingParentId,MeetingContext: meetingContext,InitialContext : {Caller:{All:true}}}});
    //store.showRibbonIcon(viewport,{"iconId":'startNailup'});
    let agreementData = {};
    agreementData = {"ActionType":data.ActionType,Action: data.Action,SearchString: data.SearchString};
    var insertData ={};
    
    insertData.PostComponentID = currentContext.grantItem.GrantRightID ;
    insertData.PostGrantPE = currentContext.grantItem.GrantPE;
    insertData.PostcredentialId = currentContext.AttributionID;
    var insertPostData ={};
    insertPostData.PostText = data.SearchString;
    insertPostData.AttributionID = currentContext.AttributionID;
    insertData.Action = agreementData.Action;
    insertData.ActionType = agreementData.ActionType;
    insertData.SearchString = data.SearchString;
    insertPostData.mode = 'Web';
    var msgTime = new Date();
    insertPostData.CreationTime = msgTime;
    insertPostData.UpdateTime = msgTime;

    if(agreementData.Action == 'RequestService') {
        insertData.PostRole = 'Consumer';
    } else if(agreementData.Action == 'OfferService') {
        insertData.PostRole = 'Provider';
    }
    //insertData.Role = that.OnRole;
    currentContext.SearchString= data.SearchString;
    currentContext.insertData = insertData;
    currentContext.componentId = client;
    currentContext.accountId = currentContext.AttributionID;
    let postcontacts = currentContext.grantItem.GrantPE;
    currentContext.contacts = postcontacts;
    let clientContextData = {"ActionType":agreementData.ActionType,Action: agreementData.Action,SearchString: data.SearchString};
    console.log("==Landing page data===="+agreementData.ActionType+"==="+agreementData.Action+"====="+data.SearchString);
    currentContext.clientContextData = clientContextData;
    //agreementData.ActionType = "Post";

    if(agreementData.ActionType == "Post") {
        let params = {
            componentId : marketpaceServer,//'_FFFFFFFFFFFFFF00001601999015356864_',
            command : "createMpPost",
            data : currentContext,
            Type : 'BotApi'
          }
          window.BotServices.callComponent(params, (err, result) => {
            if(result) {
              console.log("===result global createPost===========",result);
              window.top.oxygenUtil.callViewportFn(viewportId,'searchRefresh');
             }
        });
        //insertMarketplacePostData(agreementData,client,store,()=>{});
    } else {
        let params = {
            componentId : marketpaceServer,//'_FFFFFFFFFFFFFF00001601999015356864_',
            command : "createMpPost",
            data : currentContext,
            Type : 'BotApi'
          }
          window.BotServices.callComponent(params, (err, result) => {
            if(result) {
              console.log("===result global createPost===========",result);
              window.top.oxygenUtil.callViewportFn(viewportId,'searchRefresh');
             }
        });
        //insertMarketplacePostData(agreementData,client,store,()=>{});
    }

  }
  
  function getAgreementInfo(SearchString,clientId) {
    console.log("==mp params==="+SearchString);
    $.ajax({
      url: "/NikhilAPythonApp-0020/System/ServerSide/index3",
      type: "POST",
      dataType: "json",
      data: { "text": SearchString, "ans": "Agree" },
      success:(response) =>{
        console.log("got agreement data");
        console.log(response);
        let mpSearchData = {What : response.result.service, When: response.result.when, Where : response.result.LOCATION, Price : response.result.QUANTITY,"UserType":"consumer","Location":{"lat":34.0194543,"lon":-118.4911912},"Distance":10};
        console.log("New Data "+JSON.stringify(that.mpSearchData));
        getProviderDatatoCall(mpSearchData,clientId);
       }
    });
  }

  function insertMarketplacePostData(insertPostData,client,store,callback) {
    console.log("add marketplace post got Event   :",JSON.stringify(insertPostData));
    let clientObj = window.botStore.getClientByID(client);
    console.log("Got client data for end call: ", clientObj);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    let createDate = new Date();
    let dataObj = {"CreateDate":createDate,"GrantID":currentContext.grantItem.GrantRightID, "OxygenPE":currentContext.grantItem.GrantPE, "Data": {"What":insertPostData.What,"When":insertPostData.When,"Where":insertPostData.Where,"Price":insertPostData.Price} };
    console.log("==data sent==",JSON.stringify(dataObj));

    //_FFFFFFFFFFFFFF00001563224112409050_
    $.ajax({
    url: "/ProviderSearch-0026/Server/posting",
    type: "POST",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify({"CreateDate":createDate,"GrantID":currentContext.grantItem.GrantRightID, "OxygenPE":currentContext.grantItem.GrantPE, "Data": {"What":insertPostData.What,"When":insertPostData.When,"Where":insertPostData.Where,"Price":insertPostData.Price} }),
    success:(response) =>{
        console.log("Adding Posting for Elastic Search done");
        console.log(response);

       }
    });
    callback(null,"Success");
}

function getProviderDatatoCall(AgreementData,attachmentRow,clientId) {
    console.log("====got agreement request",AgreementData);
    var i=0;
    let providerArr=[];
    let agreementData = {What:AgreementData.What,When:AgreementData.When,Where:'Los Angeles',Price:AgreementData.Price};
    $.ajax({
         url: "/ProviderSearch-0026/Server/lotussearch/search",
         type: "POST",
         dataType: "json",
         data: {"What": { "What": AgreementData.What },
                "Where": { "Where" : AgreementData.Where},
                "When": { "When": AgreementData.When }, //optional
                "Price": { "Price": AgreementData.Price} // optional
        },
         success:(response) =>{
             console.log("got data from provider Database");
             console.log(response);
             providerArr = response.rows

             let count = 0;
             providerArr.forEach((provider) => {
                if(count <= 0) {
                    console.log("===master provider data====="+provider.Organization.Phone+"===="+provider.Organization.Name+"==="+provider.Location.lat+"===="+provider.Location.lon);
                    let providerObj = JSON.parse(JSON.stringify(provider));
                    createLead(AgreementData, attachmentRow,providerObj,clientId);
                    initiateCall(AgreementData, attachmentRow,providerObj,clientId);
                    count++;
                }
             });
         }
     });
}

function initiateCall(AgreementData, attachmentRow,providerObj,clientId) {
    let mode;let message = "";
    mode = "invite";
    let client = window.botStore.getClientByID(clientId);
    console.log("Got client data for end call: ", client);
    
    let inviteObj = {"to":{"tope":[],
                          "componentid":[],
                          "email":[],
                          "phone":[]},
                    "thread":client.ClientLeft,
                    "subject":client.ClientRight,
                    "ClientID" : client.Client,
                    "message":message,
                    "mode":mode,"callType":"MEETING","batchsize":'10',"dialerMode":"Meeting"};;

      //finalcontact.forEach((label)=>{
          //(inviteObj.to.phone).push(providerObj.Organization.Phone);
          let testphone = "+16035933691";
          (inviteObj.to.phone).push(testphone);
      //});

    window.BotServices.callManagerExec(inviteObj,()=>{});
}

function createLead(agreementData,attachmentRow, providerObj,clientId) {
    let ConvertProviderDataToRows = {};
    let clientObj = window.botStore.getClientByID(clientId);
    console.log("Got client data for end call: ", clientObj);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    let reqContext = JSON.parse(clientObj.CurrentContext);
    let meetingContext = JSON.parse(clientObj.MeetingContext);
    console.log("===master provider data====="+providerObj.Organization.Phone+"===="+providerObj.Organization.Name+"==="+providerObj.Location.lat+"===="+providerObj.Location.lon);
    if(providerObj.Organization.Phone) {
        ConvertProviderDataToRows.PostID = providerObj._id;
        ConvertProviderDataToRows.GrantRightDN = providerObj.Organization.Name;
        ConvertProviderDataToRows.Categories = providerObj.Organization.Categories;
        ConvertProviderDataToRows.Distance = providerObj.Distance;
        ConvertProviderDataToRows.path = "OUT";
        ConvertProviderDataToRows.latitude = providerObj.Location.lat;
        ConvertProviderDataToRows.longitude = providerObj.Location.lon;
        ConvertProviderDataToRows.phone = providerObj.Organization.Phone;
        let str = providerObj.Organization.Phone;

        let RegPhone = str.split(",");
        ConvertProviderDataToRows.RegPhone = RegPhone[0];

        /*that.callComponent(that.serverComponent.Node,'getContactInfo', {search : {PhoneNo:RegPhone[0]}, contact : that.componentContext}, (err, res) => {
            if(err){
                console.log("==provider contact error==="+JSON.stringify(err));
            } else {
                if(res.data && res.data.length > 0) {*/
     //               console.log("==provider contact data==="+JSON.stringify(res));
                    //=============create post for provider data================
                    var insertData ={};
                    insertData.Post = agreementData.What;
                    insertData.PostTime = agreementData.When;
                    insertData.PostPrice = agreementData.Price;
                    insertData.PostLocation =agreementData.Where;
                    insertData.PostComponentID = currentContext.grantItem.GrantRightID ;
                    insertData.PostGrantPE = currentContext.grantItem.GrantPE;
                    insertData.PostcredentialId = currentContext.AttributionID;
                    insertData.ContactName = agreementData.ContactName;
                    insertData.Location = agreementData.Location;
                    insertData.Distance = agreementData.Distance;
                    let assignRole = null;

                    if(agreementData.Action == 'RequestService') {
                        insertData.PostRole = 'Provider';
                        assignRole = 'Consumer';
                    } else if(agreementData.Action == 'OfferService') {
                        insertData.PostRole = 'Consumer';
                        assignRole = 'Provider';
                    } else {
                        insertData.PostRole = 'Consumer';
                        assignRole = 'Provider';
                    }
                    //insertData.Role = that.OnRole;
                    currentContext.insertData = insertData;
                    currentContext.postcontacts = currentContext.grantItem.GrantPE;
                    currentContext.postData = attachmentRow;

                    let clientContextData = {"ActionType":agreementData.ActionType,Action: agreementData.Action,SearchString: agreementData.SearchString,What:agreementData.What,When:agreementData.When,Where:agreementData.Where,Price:agreementData.Price,ProviderMasterData:ConvertProviderDataToRows};
                    //console.log("==Landing page data===="+that.ActionType+"==="+that.Action+"==="+insertData.PostRole+"====="+that.SearchString);
                    currentContext.clientContextData = clientContextData;
                    
                    let params = {
                        componentId : marketpaceServer,//'_FFFFFFFFFFFFFF00001601999015356864_',
                        command : "createMarketPlaceLead",
                        data : currentContext,
                        Type : 'BotApi'
                      }
                      window.BotServices.callComponent(params, (err, result) => {
                        if(result) {
                            console.log("===result createMarketPlaceLead===========",result);
                            let params = {
                                componentId : marketpaceServer,//'_FFFFFFFFFFFFFF00001601999015356864_',
                                command : "assignLead",
                                data : {"Lead": result,"Provider":providerObj,"Role":assignRole,"Context":reqContext},
                                Type : 'BotApi'
                            }
                            window.BotServices.callComponent(params, (assignerr, assignresult) => {
                                if(result) {
                                    console.log("===result assignLead===========",assignresult);
                                }
                            });

                            //let url = "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/marketplace-wc/dist/js/app.js";
                            // let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-marketplace',"URL":url};
                            //window.BotServices.openChildPanel({ClientID : client, DisplayName : 'Marketplace', Termination : terminationUrl}, ()=>{});
                        }
                    });
                            //=============create post for provider data end============
  /*              }
            }
        });*/
    }
}

function grantTransaction() {
    $.ajax({
        url: "https://producing-oxygen-server.laxroute53.com/oxygen-accounting/api/wallet/transaction/grant",
        type: "POST",
        dataType: "json",
        data: { 
            "source": "booking", // if you are using booking system
            "amount": "100",
            "currency": "CRD",
            "type": "Transfer", // "Transfer" in case paying somebody or "Purchase" if you buy something from woocommerce
            "status": "",
            "from_attribution_id": "17981",//payer attribution id
            "to_attribution_id": "15", //payee attribution id
            "from_pe": "",
            "to_pe": "",
            "from_currency": "CRD", // if you are paying from wallet its "CRD"
            "by_currency": "CRD", // keep it "USD"
            "to_currency": "CRD",
            "t1": "",
            "t2": "",
            "items": [{
            "name": "Booking for Service (#ref - 123456", //${appointmentId})
            "quantity": 1,
            "price": 100,
            }],
            "from": {
            "name": "kamalsimplia",
            "email": "kamal.simplia@gmail.com",
            "attribute_id": "17981"
            },
            "to": {
            "name": "kamal",
            "email": "kamal.jt.kr@gmail.com",
            "attribute_id": "15"
            }
        },
        success:(response) =>{
            console.log("got data from create Transaction");
            console.log(response);
        }
    }); 
}

function ConfirmAgreement(client, data, store) {
    /* Create Indexes for Root Menu */
    console.log("Got data for confirm agreement: ", client,"====params====",data);
    let clientObj = window.botStore.getClientByID(client);
    console.log("Got client data for end call: ", clientObj);
    let currentContext = JSON.parse(clientObj.CurrentContext);
    let meetingContext = JSON.parse(clientObj.MeetingContext);
    //window.BotServices.callManagerApi({action:'stopCall', data : {ClientID : client,ConferenceID : meetingContext.MeetingId,MeetingParentId:meetingContext.MeetingParentId,MeetingContext: meetingContext,InitialContext : {Caller:{All:true}}}});
    //store.showRibbonIcon(viewport,{"iconId":'startNailup'});
    let agreementData = {};
    agreementData = {"What":data.Title,"When":data.When,"Where":data.Where,"Price":data.Price,"ContactName":data.Name,"Location":data.Location,"Distance":data.Distance,"ActionType":data.ActionType,Action: data.Action,SearchString: data.SearchString};
    var insertData ={};
    
    insertData.Post = agreementData.What;
    insertData.PostTime = agreementData.When;
    insertData.PostPrice = agreementData.Price;
    insertData.PostLocation =agreementData.Where;
    insertData.PostComponentID = currentContext.grantItem.GrantRightID ;
    insertData.PostGrantPE = currentContext.grantItem.GrantPE;
    insertData.PostcredentialId = currentContext.AttributionID;
    insertData.ContactName = agreementData.ContactName;
    insertData.Location = agreementData.Location;
    insertData.Distance = agreementData.Distance;
    var insertPostData ={};
    insertPostData.PostText = data.SearchString;
    insertPostData.When = agreementData.When;
    insertPostData.Price = agreementData.Price;
    insertPostData.Where =agreementData.Where;
    insertPostData.What = agreementData.What;
    insertPostData.AttributionID = currentContext.AttributionID;
    insertData.ContactName = agreementData.ContactName;
    insertData.Location = agreementData.Location;
    insertData.Distance = agreementData.Distance;
    insertData.Action = agreementData.Action;
    insertData.ActionType = agreementData.ActionType;
    insertData.SearchString = data.SearchString;
    insertPostData.mode = 'Web';
    var msgTime = new Date();
    insertPostData.CreationTime = msgTime;
    insertPostData.UpdateTime = msgTime;

    if(agreementData.Action == 'RequestService') {
        insertData.PostRole = 'Consumer';
    } else if(agreementData.Action == 'OfferService') {
        insertData.PostRole = 'Provider';
    }
    //insertData.Role = that.OnRole;
    currentContext.SearchString= data.SearchString;
    currentContext.insertData = insertData;
    currentContext.componentId = client;
    currentContext.accountId = currentContext.AttributionID;
    let postcontacts = currentContext.grantItem.GrantPE;
    currentContext.contacts = postcontacts;
    let clientContextData = {"ActionType":agreementData.ActionType,Action: agreementData.Action,SearchString: data.SearchString,What:agreementData.What,When:agreementData.When,Where:agreementData.Where,Price:agreementData.Price};
    console.log("==Landing page data===="+agreementData.ActionType+"==="+agreementData.Action+"====="+data.SearchString);
    currentContext.clientContextData = clientContextData;
    //agreementData.ActionType = "Post";

                                                                                                                                                                                                                                                                                                                            if(agreementData.ActionType == "Post") {
        let params = {
            componentId : marketpaceServer,//'_FFFFFFFFFFFFFF00001601999015356864_',
            command : "createMarketPlacePost",
            data : currentContext,
            Type : 'BotApi'
          }
          window.BotServices.callComponent(params, (err, result) => {
            if(result) {
              console.log("===result createMarketPlacePost===========",result);
           //   let url = "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/marketplace-wc/dist/js/app.js";
             // let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-marketplace',"URL":url};
              //window.BotServices.openChildPanel({ClientID : client, DisplayName : 'Marketplace', Termination : terminationUrl}, ()=>{});
            }
        });
        insertMarketplacePostData(agreementData,client,store,()=>{});
    } else {
        let params = {
            componentId : marketpaceServer,//'_FFFFFFFFFFFFFF00001601999015356864_',
            command : "createMarketPlacePost",
            data : currentContext,
            Type : 'BotApi'
          }
          window.BotServices.callComponent(params, (err, result) => {
            if(result) {
              console.log("===result createMarketPlacePost===========",result);
           //   let url = "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/marketplace-wc/dist/js/app.js";
             // let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-marketplace',"URL":url};
              //window.BotServices.openChildPanel({ClientID : client, DisplayName : 'Marketplace', Termination : terminationUrl}, ()=>{});
            }
        });
        insertMarketplacePostData(agreementData,client,store,()=>{});
    }

    /*if(agreementData.ActionType == "Post"){
        that.callComponent(that.serverComponent.Node,"createMarketPlacePost",that.componentContext,(err,res) => {
            if(err) {
                that.debugLog("Agreement","CreateMarketPlacePostError",err);
            } else {
                that.debugLog("Agreement","CreateMarketPlacePostData",res);
                if(res) {
                    insertData.PostAccountId = res.data;
                    that.componentContext.insertData = insertData;
                    that.callComponent(that.serverComponent.Node, 'openMarketPlace', that.componentContext, (error, responseData) => {
                        if(!error && responseData.data.clientNodeId) {
                            let panel;
                            if(panel = that.Y.screenManager.allComponentInstances[responseData.data.clientNodeId]) {
                                //panel.doSearch(agreementData.SearchString, ()=>{});
                                panel.doSearch({"What":agreementData.What,"When":agreementData.When,"Where":agreementData.Where,"Price":agreementData.Price,"UserType":"consumer","Location":agreementData.Location,"Distance":agreementData.Distance}, ()=>{});
                            }
                        }

                    });
                }
            }
        });
    } else {
        that.componentContext.insertData = insertData;
        that.callComponent(that.serverComponent.Node, 'openMarketPlace', that.componentContext, (error, responseData) => {
            if(!error && responseData.data.clientNodeId) {
                let panel;
                if(panel = that.Y.screenManager.allComponentInstances[responseData.data.clientNodeId]) {
                    panel.doSearch({"What":agreementData.What,"When":agreementData.When,"Where":agreementData.Where,"Price":agreementData.Price,"UserType":"consumer","Location":agreementData.Location,"Distance":agreementData.Distance}, ()=>{});
                }
            }
        });
    }*/
  }

  export {
    ConfirmAgreement,
    ConfirmGlobalAgreement,
    ConfirmRTablePost,
    ConfirmGlobalRTablePost,
    getProviderDatatoCall,
    getAgreementInfo,
    CreateConversationPost,
    grantTransaction
  }
  